import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {SensordataComponent} from '../sensordata/sensordata.component';
import {SharedService} from '../../shared.service';
import {CookieService} from 'ngx-cookie';
import {UserPreferenceService} from '../services/user.preferences.service';
import {EcareConfigurationService} from '../services/ecareconfiguration.service';
import {DataStreamService} from '../services/datastream.service';
import {UserService} from '../services/user.service';
import {DeviceService} from '../services/device.service';
import {ModalDismissReasons, NgbCalendar, NgbModal, NgbTimepickerConfig, NgbTimeStruct} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute, Router} from '@angular/router';
import {WebSocketService} from '../websockets/websocket.service';
import {EcareSecurityService} from '../services/ecare_security_service';
import {ToastrService} from 'ngx-toastr';
import {CampaignService} from '../campaign/service/campaign.service';
import {DataAvailabilityService} from '../data-availability/data-availability-service/dataavailability.service';
import * as moment from 'moment';
import {FormControl} from '@angular/forms';
import {SensorDataService} from '../services/sensordata.service';
import {interval} from 'rxjs';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-history-data',
  templateUrl: './history-data.component.html',
  styleUrls: ['./history-data.component.css']
})
export class HistoryDataComponent extends SensordataComponent implements OnInit, AfterViewInit, OnDestroy {
  events = {};
  dataLoaded: boolean = false;
  dataStreamList: any;
  loading = true;
  campaignId: any;
  currentCampaign: any;
  dataStartDate: any;
  dataEndDate: any;
  closeResult: any;
  queryparams: any;
  device: any;
  selectionModel = [];
  allSelected = true;
  streamGroups = {};
  start = '';
  private multipleSignalsForm: any;
  private hideDisabledStreams: boolean;
  private deviceGroup: { categories: {}; device: any };
  private object: any;
  private stompClient: any;
  private selectedDate: any;
  private loadingAvailableData: any;
  time: NgbTimeStruct = {hour: 13, minute: 30, second: 0};
  startDate: any;
  private dataAvailabilityList: any[];
  timeList = [];
  date = new FormControl(new Date().getTime());
  private historyStartDate: any;
  private maxTimeRange: number;
  downloading = false;
  public selectedMoment = new Date();
  resampling: any;
  applyFilters: any;
  public selectedMoments = [new Date(), new Date()];
  private textMsg: string;
    private nodata = false;
  selectedTime: any;
  private cprogressbarValue = 0;
  curSec = 0;
  constructor(pagedata: SharedService
      , cookieService: CookieService
      , userPreferences: UserPreferenceService
      , configurationService: EcareConfigurationService
      , dataStreamService: DataStreamService
      , userService: UserService
      , deviceService: DeviceService
      , sharedService: SharedService
      , private modalService: NgbModal
      , private route: ActivatedRoute
      , private router: Router
      , private webSocketService: WebSocketService
      , private securityService: EcareSecurityService
      , private toastr: ToastrService
      , config: NgbTimepickerConfig
      , private calendar: NgbCalendar, private campaignService: CampaignService
      , private dataavailabilityService: DataAvailabilityService, public datePipe: DatePipe
      , private sensorDataService: SensorDataService) {
      super(pagedata, cookieService, userPreferences, configurationService, dataStreamService
          , userService, deviceService, sharedService);
      this.startTimer(12)
      setTimeout(() => { this.loading = false; }, 12000);
      this.queryparams = this.route.queryParams
          .subscribe(params => {
            this.campaignId = params['campaignId'] || '';
            this.deviceId = params['deviceId'] || '';
            this.start = params['start'] || '';
          });
      this.getADevice(this.deviceId).subscribe(device => {
        this.device = device;
      });
    this.loadData(this.campaignId, this.deviceId);
    config.seconds = true;
    config.spinners = false;
    config.size = 'small';
    this.object = Object;
    // If no param, select today
    if (this.start === '') {
      this.selectToday();
      let date = this.date.value;
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      this.historyStartDate = date.getTime();
    } else {
      // this.date = moment(this.start);
      this.historyStartDate =new Date(this.start);
    }

    const date = new FormControl(moment());
    this.startDate = moment(date);
    this.startDate.minutes(0);
    this.startDate.second(0);
    this.startDate.millisecond(0);
      const quarterHours = ['00', '15', '30', '45'];
      for(let i = 0; i < 24; i++) {
          for(let j = 0; j < 4; j++) {
              // Using slice() with negative index => You get always (the last) two digit numbers.
              this.timeList.push( ('0' + i).slice(-2) + ':' + quarterHours[j] );
          }
      }
      this.selectedTime = this.timeList[0];

    // this.calculateMaxTimeRange();
  }

  startTimer(seconds: number) {
    const time = seconds;
    const timer$ = interval(1000);

    const sub = timer$.subscribe((sec) => {
      this.cprogressbarValue = this.cprogressbarValue + 8.33
      if (this.curSec === seconds) {
        sub.unsubscribe();
      }
    });
  }

  ngOnInit() {
    setTimeout(() => {
      this.dataStreamList = this.dataStreams;
      console.log('==================== GOT DATASTREAMS ======================= ');
      console.log(this.dataStreams)
      console.log('==================== GOT DATASTREAMS END ======================= ');
    }, 12000);
  }

  ngAfterViewInit(): void {
  }

  /* open a Modal Component from this component and suscribe to select event*/
  initSensorsModal() {
    let hideDisabledStreams = false;
    let hasStreamsToDisplay = true;

    const initialState = {
      streams: this.dataStreams,
      devices: this.devices,
      settings: this.settings,
      categoryLabels: this.labels,
      hideDisabledStreams: false,
      hasStreamsToDisplay: true
    };
    for (let i = 0, len = this.dataStreams.length; i < len; i++) {
      this.selectionModel[this.dataStreams[i].id] = this.settings.export[this.dataStreams[i].id].selected;

      if ((this.hasStreamsToDisplay
          && this.dataStreams[i].enabled === false) || (this.device !== null && this.dataStreams[i].deviceId !== this.device.id)) {
        continue; //continue
      }
      this.deviceGroup = this.streamGroups[this.dataStreams[i].deviceId];
      if( !this.deviceGroup ) {
        this.deviceGroup = {
          device: this.resolveDevice(this.dataStreams[i].deviceId),
          categories: {}
        };
        this.streamGroups[this.dataStreams[i].deviceId] = this.deviceGroup;
      }
      const displayCategoryName = this.labels[this.dataStreams[i].dataStreamType.category].defaultValue;
      let categoryGroup = this.deviceGroup.categories[displayCategoryName];
      if (!categoryGroup) {
        categoryGroup = {
          streams: []
        };
        this.deviceGroup.categories[displayCategoryName] = categoryGroup;
      }
      //this.streamGroups = Array.of(this.streamGroups);
      categoryGroup.streams.push(this.dataStreams[i]);
    }
    this.updateSelectAllStreams(true, hideDisabledStreams);
  }

  updateSelectAllStreams(defaultValue, hideDisabledStreams) {
    defaultValue = defaultValue === true || false;
    let checkedFound = false;
    let uncheckedFound = false;

    for (let i = 0; i < this.dataStreams.length; i++) {
      const device = this.resolveDevice(this.dataStreams[i].deviceId);
      if (device.deactivated || (hideDisabledStreams &&
          this.dataStreams[i].enabled === false)) {
        continue;
      }

      let streamId = this.dataStreams[i].id;
      let isChecked = this.selectionModel[streamId];

      checkedFound = checkedFound || isChecked;
      uncheckedFound = uncheckedFound || !isChecked;

      if (checkedFound && uncheckedFound) {
        break;
      }
      //all checked
      if (uncheckedFound === false){
        this.allSelected = true;
        if(this.multipleSignalsForm){
          this.multipleSignalsForm = this.allSelected;
        }

      } else if (checkedFound === false){ // All unchecked
        this.allSelected = false;
        if(this.multipleSignalsForm){
          this.multipleSignalsForm = this.allSelected;
        }

      } else {
        this.allSelected = defaultValue;
      }

    }
  }

  selectAllStreams() {
    this.allSelected = !this.allSelected;
    if (this.multipleSignalsForm){
      this.multipleSignalsForm = this.allSelected;
    }

    for (let i = 0; i < this.dataStreams.length; i++){
      if (this.hideDisabledStreams &&
          this.dataStreams[i].enabled === false){
        continue;
      }

      const streamId = this.dataStreams[i].id;
      this.selectionModel[streamId] = this.allSelected;
    }
  }

  savePreference() {
    let prefs = {};
    console.log(this.settings.chart)
    for (let key in this.selectionModel) {
      let value = this.selectionModel[key];
      this.settings.chart[key].selected = value;
      this.settings.export[key].selected = value;
      prefs['sensorData/chart/' + key + '/display'] = value ? true : false;
    }
    // This is just to trigger a manual change event as changing variables inside object is not considered
    this.settings  = JSON.parse(JSON.stringify(this.settings));

    // @ts-ignore
    this.userPreferences.update(prefs, this.securityService.getUserDetails()).subscribe(
        response => {
          this.userPreferences.get('sensorData/*', this.securityService.getUserDetails())
              .subscribe(result => {
                this.preferences = result;
                this.initChartOrderSettings();
              });
          this.toastr.success('Preferences has been updated!', 'Successful!');
        });
  }

  selectionChanged(selectedId, event) {
    this.selectionModel[selectedId] = event;
  }


  resolveDevice(deviceId){
    return this.devices.find(x => x.id === deviceId);
  }

  ngOnDestroy(){
  }

  open(content) {
    this.initSensorsModal();
    this.modalService.open(content, { size: 'lg', backdrop: 'static' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    this.streamGroups = {};
    if (reason === 'export_csv') {
      this.exportSignals(0);
    }
    if (reason === 'export_zip') {
      this.exportSignals(1);
    }
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  exportSignals(isZip) {
    this.downloading = false;
    let dataStreamIds = [];

    this.dataStreams.forEach(stream => {
      if (this.selectionModel[stream.id]) {
        dataStreamIds.push(stream.id);
      }
    });

    if (dataStreamIds.length !== 0) {
      console.log('========================')
      const from = this.selectedMoments[0];
      console.log(from)
      const to = this.selectedMoments[1];
      console.log(to)
      this.downloading = true;
      this.sensorDataService.exportMultipleSignals(dataStreamIds, from, to, this.resampling, this.applyFilters, isZip)
          .subscribe(result => {
            this.downloading = false;
            this.toastr.success('Data downloaded successfully!');
          },
          error => {
            this.downloading = false;
            this.toastr.warning('No data available for selected period!');
          });
    }
  }

  selectToday() {
    this.date = new FormControl(new Date());
  }

  selectLastWeek() {
    let d = new Date();
    d.setDate(d.getDate() - 7) // Last week
    this.date = new FormControl(d);
  }

    selectLastMonth() {
      let d = new Date();
      d.setMonth(d.getMonth() - 1); // Last week
      this.date = new FormControl(d);
    }

    viewLiveData() {
        this.router.navigate([ '/elasticcare/live-data' ], { queryParams: { campaignId: this.campaignId, deviceId: this.deviceId} });
    }

    getAvailableData(){

          this.campaignService.getCampaignsDetails(this.campaignId).subscribe(data => {
            //console.log('campaign ::' + data.json());
            this.currentCampaign = data.json();
            this.getAvailableDataRanges();
          }, (error) => {
            //this.toastr.error('', 'Please try again');
          });

    }

    getAvailableDataRanges(){

        this.loadingAvailableData = true;

        this.dataStartDate = this.currentCampaign.startDate;
        if(this.currentCampaign.expiryDate!== undefined || this.currentCampaign.expiryDate !==null){
             this.dataEndDate = this.currentCampaign.expiryDate;
        }

        this.dataavailabilityService.getAllDataAvailable(this.campaignId, this.datePipe.transform(this.dataStartDate, 'yyyyMMddHHmmss'), this.datePipe.transform(this.dataEndDate, 'yyyyMMddHHmmss'), 0 , 20)
            .subscribe(data => {
                const response: any = data.json();
                this.dataAvailabilityList = response.dataAvailabilityList[0].deviceDataTime;
                console.log(this.dataAvailabilityList)
            }, (error) => {
                this.toastr.error('', 'Could not fetch available data!');
            }, () =>{
                this.loadingAvailableData = false;
                if (this.dataAvailabilityList.length === 0){
                    this.nodata = true;
                }else{
                    this.nodata = false;
                }
        });
    }


   /* $scope.exportData = function(dataStream) {
        if(dataStream) {
            var timeRange = $scope.settings.chart[dataStream.id].timeRange;
            var from = $scope.historyStartDate;
            var to = moment($scope.historyStartDate).add(timeRange);
            sensorDataService.exportSensorData(dataStream.id, from, to)
                .then(function(result) {
                    if(result.data.byteLength==0){
                        $uibModal.open({
                            templateUrl: 'views/popups/alertPopup.html',
                            controller: function($uibModalInstance, $scope){
                                $scope.textMsg='No data available for export!';
                                $scope.close = function () {
                                    $uibModalInstance.dismiss('cancel');
                                };
                            }
                        });
                    }
                });
        }
    };*/
  selectionResamplingChanged() {

  }

  viewSelected(selectedDate) {
      this.historyStartDate = selectedDate;
      this.selectedTime = this.timeList[0];
  }

  viewSelectedOnTimeChange() {
    let hhmm = this.selectedTime.split(':');
    let date = this.date.value;
    date.setHours(hhmm[0]);
    date.setMinutes(hhmm[1]);
    this.historyStartDate = null;
    this.historyStartDate = date;
  }
}
